import { render, staticRenderFns } from "./CounterTicketRequest.vue?vue&type=template&id=2f63f76a&scoped=true&"
import script from "./CounterTicketRequest.vue?vue&type=script&lang=js&"
export * from "./CounterTicketRequest.vue?vue&type=script&lang=js&"
import style0 from "./CounterTicketRequest.vue?vue&type=style&index=0&id=2f63f76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63f76a",
  null
  
)

export default component.exports